import React, { Fragment } from 'react';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import messages from './reportGeneralPanelTRIMessages';
import ResultCard from '../ReportResultCard';

const GeneralDetailCard = (props) => (
  <div>
    {(props.applicationCard || props.schoolCard) && (
      <Row>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.countStudents)}
            value={props.cardDetailTRI.countStudents}
          />
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          {props.applicationCard ? (
            <ResultCard
              cardTRI
              label={props.intl.formatMessage(messages.schoolCountStudents)}
              value={props.cardDetailTRI.countSchools}
            />
          ) : (
            <ResultCard
              cardTRI
              label={props.intl.formatMessage(messages.schoolPositon)}
              value={props.cardDetailTRI.schoolPositon}
            />
          )}
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.avgGradeSchool)}
            value={props.cardDetailTRI.avgGradeSchool}
          />
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.MaxGradeSchool)}
            value={props.cardDetailTRI.MaxGradeSchool}
          />
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.MinGradeSchool)}
            value={props.cardDetailTRI.MinGradeSchool}
          />
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.avgGradeWriting)}
            value={props.cardDetailTRI.avgGradeWriting}
          />
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.MaxGradeWriting)}
            value={props.cardDetailTRI.MaxGradeWriting}
          />
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.MinGradeWriting)}
            value={props.cardDetailTRI.MinGradeWriting}
          />
        </Col>
      </Row>
    )}
    {!props.applicationCard && !props.schoolCard && (
      <Row>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.countStudents)}
            value={props.cardDetailTRI.countStudents}
          />
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.schoolPositon)}
            value={props.cardDetailTRI.schoolPositon}
          />
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.groupPosition)}
            value={props.cardDetailTRI.groupPosition}
          />
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.avgGradeGroup)}
            value={props.cardDetailTRI.avgGradeGroup}
          />
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.MaxGradeGroup)}
            value={props.cardDetailTRI.MaxGradeGroup}
          />
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.MinGradeGroup)}
            value={props.cardDetailTRI.MinGradeGroup}
          />
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.MaxGradeWriting)}
            value={props.cardDetailTRI.MaxGradeWriting}
          />
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.MinGradeWriting)}
            value={props.cardDetailTRI.MinGradeWriting}
          />
        </Col>
      </Row>
    )}
  </div>
);

export default compose(injectIntl)(GeneralDetailCard);
